'use client';

import { FC, useRef } from 'react';

import useDevice from '@/hooks/useDevice';
import { useLazyVideoSource } from '@/hooks/useLazyVideoSource';
import { useViewportVideosPlayback } from '@/hooks/useViewportVideosPlayback';
import { BasicProps } from '@/types/common';

import css from './style.module.scss';

const VideoBackgroundFooter: FC<BasicProps> = ({ children }) => {
	const device = useDevice();
	const wrapRef = useRef<HTMLDivElement>(null);

	const shouldLoadVideo = useLazyVideoSource(wrapRef);
	useViewportVideosPlayback([wrapRef]);

	return (
		<div ref={wrapRef} className={css.videoWrapper}>
			{device === 'desktop' ? (
				<video muted loop playsInline className={css.videoBackground} preload="none">
					{shouldLoadVideo ? (
						<source src="/assets/video/mp4/footer-chubs.mp4" type="video/mp4" />
					) : null}
					Your browser does not support the video tag.
				</video>
			) : null}

			<div className={css.overlay}>{children}</div>
		</div>
	);
};

export default VideoBackgroundFooter;
